import {
    LICENCE_TYPE,
    TVRO_SYSTEM_DETAILS,
    QUANTITY_OF_TV_OUTPUT_POINTS,
    DETAILS_OF_TV_OUTPUT_POINTS,
    DETAILS_OF_SATELLITE_AND_TV_CHANNELS_PROGRAMMES,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/TVROLicence';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTVRO = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let detailsOfTVOutputPoints = [];
    let detailsOfSatelliteAndTvChannelsProgrammes = [];
    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.detailsOfTvOutputPointS && licenceDetails.detailsOfTvOutputPointS.length > 0) {
        detailsOfTVOutputPoints = licenceDetails?.detailsOfTvOutputPointS.map((value: any, i: number) => ({
            no: value?.rowId ?? '-',
            'location-room-description-room-number': value?.locationRoomDescriptionRoomNumber ?? '-',
            'quantity-of-tv-output-points': value?.quantityOfTvOutputPoints ?? '-'
        }));
    }

    if (
        licenceDetails &&
        licenceDetails.SatelliteAndTvChannelProgrammeList &&
        licenceDetails.SatelliteAndTvChannelProgrammeList.length > 0
    ) {
        detailsOfSatelliteAndTvChannelsProgrammes = licenceDetails?.SatelliteAndTvChannelProgrammeList.map(
            (value: Record<string, string>, i: number) => ({
                no: value?.rowId ?? '-',
                'satellite-name': value?.satelliteName ?? '-',
                'orbital-longitude': value?.orbitalLongitude ?? '-',
                'channel-id-number': value?.channelIdNumber ?? '-',
                'channel-programme-name': value?.channelProgrammeName ?? '-',
                'channel-programme-description': value?.channelProgrammeDescription ?? '-',
                'downlink-frequency-mhz': value?.downlinkFrequencyMHz ?? '-',
                'carrier-downlink-bandwidth-mhz': value?.carrierDownlinkBandwidthMHz ?? '-',
                'channel-downlink-bandwidth-mhz': value?.channelDownlinkBandwidthMHz ?? '-',
                'application-type': value?.applicationType ?? '-', // placeholder to be change
                'sample-clips-url': value?.URLSampleClips ?? '-' // placeholder to be change
            })
        );
    }

    const LICENCE_DURATION_MAP: Record<string, string> = {
        LD01: '12 Months',
        LD02: 'Up to 30 Days',
    };

    const USE_OF_DOWNLINK_SIGNALS: Record<string, string> = {
        UIDS01: 'View Only',
        UIDS02: 'View and Record',
        UIDS03: 'View, Record and Distribute',
        UIDS04: 'View Only',
        UIDS05: 'View Only',
        UIDS06: 'View Only',
        UIDS07: 'View Only',
        UIDS08: 'View Only',
        UIDS09: 'View and Record',
        UIDS10: 'View, Record and Distribute',
        UIDS11: 'View Only',
        UIDS12: 'View and Record',
        UIDS13: 'View, Record and Distribute',
        UIDS14: 'View Only',
        UIDS15: 'View and Record',
        UIDS16: 'View, Record and Distribute'
    };

    const TVRO_SYSTEM_IS_ON: Record<string, string> = {
        TVROSIO1: 'Rooftop',
        TVROSIO2: 'Ground',
    };

    const LicenceDurationCode = licenceDetails?.typeOfLicenceAppliedFor?.licenceDuration;
    const useOfDownlinkSignalsCode = licenceDetails?.tvroSystemDetails?.useOfDownlinkSignals;
    const tvroSystemIsOnCode = licenceDetails?.tvroSystemDetails?.tvroSystemIsOn;

    licence = {
        id: 'tv-receive-only-system-licence',
        formID: 'tv-receive-only-system-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_TYPE}-licence-duration`]: LICENCE_DURATION_MAP[LicenceDurationCode] ?? '-',
            [`${LICENCE_TYPE}-start-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityFromDate ?? '-',
            [`${LICENCE_TYPE}-expiry-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityToDate ?? '-', // placeholder to be change
            [`${LICENCE_TYPE}-sharing-dish`]: licenceDetails?.typeOfLicenceAppliedFor?.sharingDishWithAnotherLicensee ?? '-',
            [`${LICENCE_TYPE}-sharing-licence-no`]: licenceDetails?.typeOfLicenceAppliedFor?.sharingLicenceNumber ?? '-', // placeholder to be change

            [`${TVRO_SYSTEM_DETAILS}-purpose-of-downlink`]: licenceDetails?.tvroSystemDetails?.purposeOfDownlink ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-location-of-tvro-dish`]: licenceDetails?.tvroSystemDetails?.locationOfTvroDish ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-tvro-system-is-on`]: TVRO_SYSTEM_IS_ON[tvroSystemIsOnCode] ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-height-of-the-antenna-dish-in-meters`]:
                licenceDetails?.tvroSystemDetails?.heightOfTheAntennaDishInMetres ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-height-of-the-building-in-metres-above-mean-sea-level`]:
                licenceDetails?.tvroSystemDetails?.heightOfTheBuildingInMetresAboveMeanSeaLevelAmsl ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-height-of-the-building-with-the-antenna-dish-in-metres`]:
                licenceDetails?.tvroSystemDetails?.heightOfTheBuildingWithTheAntennaDishInMetresAmsl ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-is-the-antenna-dish-located-at-the-highest-point-of-the-building`]:
                licenceDetails?.tvroSystemDetails?.isTheAntennaDishLocatedAtTheHighestPointOfTheBuilding ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-use-of-downlink-signals`]: USE_OF_DOWNLINK_SIGNALS[useOfDownlinkSignalsCode] ?? '-',
            [`${TVRO_SYSTEM_DETAILS}-no-of-dishes`]: licenceDetails?.tvroSystemDetails?.noOfDishes ?? '-', // placeholder to be change

            [`${QUANTITY_OF_TV_OUTPUT_POINTS}-total-number-of-rooms`]: licenceDetails?.numberOfTvOutputPointS?.totalNumberOfRooms ?? '-',
            [`${QUANTITY_OF_TV_OUTPUT_POINTS}-total-number-of-tv-output-points`]:
                licenceDetails?.numberOfTvOutputPointS?.totalNumberOfTvOutputPoints ?? '-',

            [`${DETAILS_OF_TV_OUTPUT_POINTS}-list`]: detailsOfTVOutputPoints ?? [...detailsOfTVOutputPoints],

            [`${DETAILS_OF_SATELLITE_AND_TV_CHANNELS_PROGRAMMES}-list`]: detailsOfSatelliteAndTvChannelsProgrammes ?? [
                ...detailsOfSatelliteAndTvChannelsProgrammes
            ],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const tvroPayload = {
    formatTVRO
};

export default tvroPayload;
